import React from 'react'
import {Container, Row, Col, Button, Carousel} from "react-bootstrap"
import {Link, useHistory} from "react-router-dom"
import LightSpeed from 'react-reveal/LightSpeed';

import Lamborghini from "../../style/Img/Lamborghini/LamborghiniHuracane.jpg"
import LamborghiniIn from "../../style/Img/Lamborghini/Lamborghini_Inside.jpg"
import LamborghiniRe from "../../style/Img/Lamborghini/Lamborghini_Retro.jpg"
import Audi from "../../style/Img/Audi/Audi A3.jpg"
import AudiIn from "../../style/Img/Audi/Audi_Inside.jpg"
import AudiRe from "../../style/Img/Audi/Audi_Retro.jpg"
import Panda from "../../style/Img/Panda/Panda.jpg"
import PandaIn from "../../style/Img/Panda/Panda_Inside.jpg"
import PandaRe from "../../style/Img/Panda/Panda_Retro.jpg"

function ListaAuto() {
    let history = useHistory();

    return (
        <Container fluid>
            {/* SEZIONE BANNER */}
            <Container fluid id="banner_recovered" className="head-banner text-center text-white">
            <Container>
            <Row>
                <Col>
                    <h1><strong>8-Bit Motors</strong></h1>
                </Col>
            </Row>
        </Container>
        </Container>

        {/* SEZIONE INTRODUZIONE */}
        <Container className=" text-center mt-3">
            
            <h2><strong>Catalogo Automobili</strong></h2>
            <h3>Le nostre auto disponibili al noleggio 24/7</h3>
            
        </Container>

        {/* SEZIONE AUTOMOBILI */}
        <Container className="mt-4">
            <Row>
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Lamborghini Huracane"}>
                <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Lamborghini}
                        alt="First slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={LamborghiniIn}
                        alt="Second slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={LamborghiniRe}
                        alt="Third slide"
                        />
                    </Carousel.Item>
                </Carousel>
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Lamborghini Huracane</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        5€ all'ora


                        </p>

                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Lamborghini Huracane")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>

            <Row className="mt-4">
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Audi A3"}>
                <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Audi}
                        alt="First slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={AudiIn}
                        alt="Second slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={AudiRe}
                        alt="Third slide"
                        />
                    </Carousel.Item>
                </Carousel>
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Audi A3</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        3€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Audi A3")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>

            <Row className="mt-4">
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Fiat Panda"}>
                <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Panda}
                        alt="First slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={PandaIn}
                        alt="Second slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={PandaRe}
                        alt="Third slide"
                        />
                    </Carousel.Item>
                </Carousel>
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Fiat Panda</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        2€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Fiat Panda")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>
        </Container>
        </Container>
    )
}

export default ListaAuto
